import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyApplyBar } from "@/components/StickyApplyBar";
import { CookieConsent } from "@/components/CookieConsent";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { Program } from "@/sections/Program";
import { Revenue } from "@/sections/Revenue";
import { Requirements, WhyPartner } from "@/sections/Requirements";
import { Fleet } from "@/sections/Fleet";
import { ServiceArea } from "@/sections/ServiceArea";
import { Expectations, FAQ, FinalCTA } from "@/sections/Trust";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Program />
        <Revenue />
        <Requirements />
        <Fleet />
        <WhyPartner />
        <ServiceArea />
        <Expectations />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyApplyBar />
      <CookieConsent />
    </div>
  );
}
